"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTrashOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M9 4c0-1.333.667-2 2-2h2c1.333 0 2 .667 2 2h3c1.333 0 2 .667 2 2v2c0 .942-.333 1.551-1 1.828V20c0 1.333-.667 2-2 2H7c-1.336 0-2.003-.667-2-2V9.828C4.333 9.552 4 8.943 4 8V6c0-1.333.666-2 1.999-2H9zm-2 6v10h10V10H7zM6 6v2h12V6H6zm3 7c0-.657.333-.99 1-1 .667-.01 1 .324 1 1v4c0 .667-.333 1-1 1s-1-.333-1-1v-4zm4 0c0-.657.333-.99 1-1 .667-.01 1 .324 1 1v4c0 .667-.333 1-1 1s-1-.333-1-1v-4z' }))); };
exports.default = SvgTrashOutline;
//# sourceMappingURL=TrashOutline.js.map